// Mock data for WrapAlot Specialty Filmz website

export const services = [
  {
    id: 1,
    title: "Commercial Vehicle Wraps",
    description: "Professional fleet graphics and commercial vehicle branding solutions that transform your business vehicles into mobile advertisements.",
    image: "https://dawn-magic-weaver.lovable.app/assets/service-commercial-wrap-BorEla3-.jpg",
    icon: "truck"
  },
  {
    id: 2,
    title: "Color Changes",
    description: "Complete vehicle color transformations with premium vinyl wraps that protect your original paint while giving you a fresh new look.",
    image: "https://dawn-magic-weaver.lovable.app/assets/service-color-change-LOdm_Ly6.jpg",
    icon: "palette"
  },
  {
    id: 3,
    title: "Architectural Window Films",
    description: "High-quality window films for buildings that provide UV protection, energy efficiency, and enhanced privacy for commercial and residential spaces.",
    image: "https://dawn-magic-weaver.lovable.app/assets/service-window-film-BOnWrPpY.jpg",
    icon: "building"
  },
  {
    id: 4,
    title: "Removals",
    description: "Expert removal of old or damaged window tinting from commercial properties, preparing surfaces for new film installation.",
    image: "https://dawn-magic-weaver.lovable.app/assets/service-removals-CRTwEslA.jpg",
    icon: "sparkles"
  },
  {
    id: 5,
    title: "Anti Graffiti Film",
    description: "Protective films that safeguard windows and surfaces from vandalism, scratches, and graffiti, making cleanup easy and cost-effective.",
    image: "https://dawn-magic-weaver.lovable.app/assets/service-anti-graffiti-B_iowylY.jpg",
    icon: "shield"
  }
];

export const portfolio = [
  {
    id: 1,
    title: "Commercial Fleet Graphics",
    category: "Business Branding",
    image: "https://dawn-magic-weaver.lovable.app/assets/commercial-wrap-real-BrnOMpjC.jpg"
  },
  {
    id: 2,
    title: "Commercial Wrap",
    category: "Custom Design",
    image: "https://dawn-magic-weaver.lovable.app/assets/commercial-wrap-new-BY97IFRq.jpg"
  },
  {
    id: 3,
    title: "Luxury Chrome Finish",
    category: "Premium Wrap",
    image: "https://dawn-magic-weaver.lovable.app/assets/luxury-wrap-lJMHKCB1.jpg"
  },
  {
    id: 4,
    title: "Storefront Protection",
    category: "Anti Graffiti Film",
    image: "https://dawn-magic-weaver.lovable.app/assets/graffiti-tint-Cr8FEPqf.jpg"
  },
  {
    id: 5,
    title: "Window Graphics",
    category: "Anti Graffiti Film",
    image: "https://dawn-magic-weaver.lovable.app/assets/graffiti-tint-2-Dy9Gar3V.jpg"
  },
  {
    id: 6,
    title: "Bentley Tint Removal",
    category: "Removals",
    image: "https://dawn-magic-weaver.lovable.app/assets/tint-removal-bentley-DAqc8hiI.jpg"
  },
  {
    id: 7,
    title: "Luxury Vehicle Service",
    category: "Removals",
    image: "https://dawn-magic-weaver.lovable.app/assets/tint-removal-black-0DRAzKXa.jpg"
  },
  {
    id: 8,
    title: "Custom Toolbox Wrap",
    category: "Custom Design",
    image: "https://dawn-magic-weaver.lovable.app/assets/toolbox-wrap-Cl6ahSuo.jpg"
  }
];

export const features = [
  "Certified installation professionals",
  "Premium quality materials",
  "5-year warranty coverage",
  "Free design consultation",
  "Competitive pricing",
  "Fast turnaround times"
];

export const contactInfo = {
  phone: "916-336-7865",
  email: "Wrapalotsf@gmail.com",
  address: {
    street: "1817 Del Paso Blvd",
    city: "Sacramento, CA 95815"
  }
};

export const navLinks = [
  { name: "Home", href: "#home" },
  { name: "Services", href: "#services" },
  { name: "Portfolio", href: "#portfolio" },
  { name: "Blog", href: "/blog" },
  { name: "FAQ", href: "#faq" }
];
